<template>
  <div>
    <div class="mrB20" />
    <sui-grid
      ref="grid1"
      :columns="gridColumns0"
      :dataset="'ds0'"
      :multiselect="true"
      :showDisplayCountControl="false"
    >
      <div class="comp_spacing" />
      <div class="btn_wrapL">
        <sui-button
          v-permission:create="pageId"
          type="button"
          class="comm_btn_gridTop"
          @click="onAddClick"
        >
          {{ $t('MSG_BTN_ADD') }}
        </sui-button>
        <sui-button
          v-permission:delete="pageId"
          type="button"
          class="comm_btn_gridTop"
          @click="onDeleteClick"
        >
          {{ $t('MSG_BTN_DEL') }}
        </sui-button>
      </div>
    </sui-grid>
    <div class="comm_btn_wrap">
      <sui-button
        v-permission:update="pageId"
        type="button"
        class="comm_btn_solid"
        @click="onSaveClick"
      >
        {{ $t('MSG_BTN_SAVE') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
import BasePage from '~cm/components/BasePage';
export default {
  name: 'PGE_CMU_00001_T06', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: '',
    },
    selectedPageId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_MDLE'),
        datafield: 'moduleName',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_SMDLE'),
        datafield: 'subModuleName',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_MANU_ID'),
        datafield: 'documentId',
        width: 150,
      }, {
        text: this.$t('MSG_TXT_MANU_VER'),
        datafield: 'documentVersion',
      }, {
        text: this.$t('MSG_TXT_RGST_USR'),
        datafield: 'firstRegistrationUserId',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
            displayType: '1',
            type: 'link',
            datafieldMap: {
              displayLanguageId: 'displayLanguageId',
              knoxId: 'knoxIdRegistration',
              userName: 'userNameRegistration',
              userGlobalName: 'userGlobalNameRegistration',
              departmentName: 'departmentNameRegistration',
              departmentEnglishName: 'departmentEnglishNameRegistration',
            },
          }, this.ds0, this.$refs.grid1);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
        width: '200px',
      }, {
        text: this.$t('MSG_TXT_RGST_DTM'),
        datafield: 'firstRegistrationDTM',
        createwidget: (r, c, v, h) => utils.getGridCellFactory().createCellDateLabel(r, c, v, h, this.ds0, this.$refs.grid1),
        initwidget: (r, c, v, h) => utils.getGridCellFactory().refreshCell(r, c, v, h),
        width: '150px',
      }],
      selectMessage: utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_PAGE')),
    };
  },
  computed: {},
  watch: {
    selectedPageId(value) {
      if (utils.isEmpty(value)) {
        this.tabGridClear();
      } else {
        this.pageManualListLoad();
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (!utils.isEmpty(this.selectedPageId)) {
        this.pageManualListLoad();
      }
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    pageManualListLoad() {
      http.request(this.pageId, 'DTS_CMU_00064', {
        path: {
          'page-id': this.selectedPageId,
        },
      }).then(res => {
        this.ds0.setRawData(res.data);
      }).catch(error => {
        console.log(error);
      });
    },
    tabGridClear() {
      this.ds0.setRawData([]);
    },
    onAddClick() {
      if (utils.isEmpty(this.selectedPageId)) {
        //utils.messageBox('warning', this.selectMessage);
        utils.messageBox('alert', null, this.$t('MSG_ALT_NOT_SEL_ITEM'));
      } else {
        utils.openLayerPopup('PGE_CMU_00012', this.onPopupClose, {
          pageInitialData: {},
          size: 'lg',
        });
      }
    },
    onPopupClose(selected) {
      if (!utils.isEmpty(selected)) {
        this.addRow(selected);
      }
    },
    addRow(list) {
      const addNewRows = [];
      const documentList = this.ds0.getRawData();
      utils.forEach(list, data => {
        const { documentId } = data;
        if (utils.findIndex(documentList, { documentId }) === -1) {
          addNewRows.push(data);
        }
      });
      this.ds0.addRows(addNewRows);
    },
    onDeleteClick() {
      if (utils.isEmpty(this.selectedPageId)) {
        //utils.messageBox('warning', this.selectMessage);
        utils.messageBox('alert', null, this.$t('MSG_ALT_NOT_SEL_ITEM'));
      } else {
        const indexes = this.ds0.getSelectedIndexes();
        this.ds0.deleteRows(indexes);
      }
    },
    getSaveData() {
      const list = [];
      const dataList = this.ds0.getRawData();
      utils.forEach(dataList, data => {
        list.push({
          documentId: data.documentId,
          pageId: this.selectedPageId,
        });
      });
      return list;
    },
    onSaveClick() {
      if (utils.isEmpty(this.selectedPageId)) {
        //utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_PAGE')));
        utils.messageBox('alert', null, this.$t('MSG_ALT_NOT_SEL_ITEM'));
        return false;
      } 

      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null,
        (/* ok */) => {
          const saveData = this.getSaveData();
          http.request(this.pageId, 'DTS_CMU_00065', {
            path: {
              'page-id': this.selectedPageId,
            },
            data: saveData,
          }).then(() => {
            utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'));
            this.ds0.submit();
          }).catch(error => {
            console.log(error);
          });
        },
        (/* cancel */) => {});
    },
  },
  datasets: [{
    id: 'ds0',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { name: 'documentId', type: 'string', map: 'documentId' },
      { name: 'documentClassificationCode', type: 'string', map: 'documentClassificationCode' },
      { name: 'documentGeneralTypeCode', type: 'string', map: 'documentGeneralTypeCode' },
      { name: 'siteId', type: 'string', map: 'siteId' },
      { name: 'moduleCode', type: 'string', map: 'moduleCode' },
      { name: 'subModuleCode', type: 'string', map: 'subModuleCode' },
      { name: 'documentVersion', type: 'string', map: 'documentVersion' },
      { name: 'documentContent', type: 'string', map: 'documentContent' },
      { name: 'documentMultiLanguageId', type: 'string', map: 'documentMultiLanguageId' },
      { name: 'documentFileSN', type: 'string', map: 'documentFileSN' },
      { name: 'attachDocumentId', type: 'string', map: 'attachDocumentId' },
      { name: 'langId', type: 'string', map: 'langId' },
      { name: 'documentDetailContent', type: 'string', map: 'documentDetailContent' },
      { name: 'pageId', type: 'string', map: 'pageId' },
      { name: 'pageCount', type: 'string', map: 'pageCount' },
      { name: 'pageIdCount', type: 'string', map: 'pageIdCount' },
      { name: 'moduleName', type: 'string', map: 'moduleName' },
      { name: 'subModuleName', type: 'string', map: 'subModuleName' },
      { name: 'documentName', type: 'string', map: 'documentName' },
      { name: 'finalModificationUserId', type: 'string', map: 'finalModificationUserId' },
      { name: 'finalModificationDTM', type: 'string', map: 'finalModificationDTM' },
      { name: 'firstRegistrationDTM', type: 'string', map: 'firstRegistrationDTM' },
      { name: 'firstRegistrationUserId', type: 'string', map: 'firstRegistrationUserId' },
      { name: 'finalModificationUserName', type: 'string', map: 'finalModificationUserName' },
      { name: 'knoxIdModification', type: 'string', map: 'knoxIdModification' },
      { name: 'knoxIdRegistration', type: 'string', map: 'knoxIdRegistration' },
      { name: 'userNameModification', type: 'string', map: 'userNameModification' },
      { name: 'userNameRegistration', type: 'string', map: 'userNameRegistration' },
      { name: 'userGlobalNameModification', type: 'string', map: 'userGlobalNameModification' },
      { name: 'userGlobalNameRegistration', type: 'string', map: 'userGlobalNameRegistration' },
      { name: 'departmentNameModification', type: 'string', map: 'departmentNameModification' },
      { name: 'departmentNameRegistration', type: 'string', map: 'departmentNameRegistration' },
      { name: 'departmentEnglishNameModification', type: 'string', map: 'departmentEnglishNameModification' },
      { name: 'departmentEnglishNameRegistration', type: 'string', map: 'departmentEnglishNameRegistration' },
      { name: 'displayLanguageId', type: 'string', map: 'displayLanguageId' },
    ],
  }],
};
</script>
<style scoped>
</style>
